'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiVendorApple = function TiVendorApple(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 11s-0.1-2.7 1.5-5l4.7-2.7s0.2 2.7-1.5 5l-4.7 2.7z m9 9.3c0-2.5 1.4-4.6 3.4-6l-1.5-1.5c-0.9-0.5-1.9-1.1-4-1.1-2.4 0-4 1.5-6.2 1.5s-3.7-1.4-5.2-1.5c-1.1 0-2.3 0-3.5 0.5-0.8 0.3-2 1.1-2.6 2-1 1-2 3.1-2.2 5.1-0.2 2-0.2 3.5 0.3 5.4 0.4 1.5 1 3 1.7 4.3 0.5 1 1 2 1.7 3 0.5 0.7 1.1 1.3 1.8 1.8 0.5 0.4 1 0.7 1.7 1 0.3 0 0.8 0.2 1.3 0.2 1-0.2 2.7-1.5 4-1.8 0.7-0.2 1.3-0.2 2.2 0 1.1 0.1 2.3 1.5 3.6 1.6 1 0.2 2 0 2.9-0.5 0.6-0.3 1.1-0.8 1.6-1.5 0.7-0.6 1.2-1.5 1.7-2.1 0.7-1.2 1.5-2.5 1.8-3.9-2.6-1-4.5-3.5-4.5-6.5z' })
        )
    );
};

exports.default = TiVendorApple;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/vendor-apple.js
// module id = 4021
// module chunks = 0